module.exports = __webpack_public_path__ + "img/outlander9.9144da7d.jpeg";